import { http } from './config'

export default {
  listandoBairro:(ibge) => {
    return http.get('bairro.php?ibge='+ibge)
  }
}